import { useMemo } from "react";

import { readState } from "@/__main__/app-state.mjs";
import { getDataFromPlayers } from "@/game-tft/get-data-from-players.mjs";
import { useRoute } from "@/util/router-hooks.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export default function useMatch() {
  const {
    parameters: [, , matchId],
  } = useRoute();
  const state = useSnapshot(readState);
  const matches = state.tft.match;
  const properMatchId = matchId?.split("_")[1]
    ? matchId.split("_")[1]
    : matchId;

  const match = useMemo(
    () => matches?.[properMatchId] || {},
    [properMatchId, matches],
  );

  return useMemo(() => {
    return { ...match, playerMatches: getDataFromPlayers(match.playerMatches) };
  }, [match, properMatchId]);
}
